import getAccommodationsAvailabilitySaga from './getAccommodationsAvailability';
import getAccommodationsSaga from './getAccommodations';

export const accommodationSagas = [
  getAccommodationsSaga,
  getAccommodationsAvailabilitySaga,
];
